import { createContext } from 'react';
import Container from './Container';

export const container = new Container();

export const ServiceContext = createContext(container);